import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { FeatureFlagsAndLimitsState } from './store/state';
import { selectDowntime } from './store/selectors';

@Injectable({
    providedIn: 'root',
})
export class FeatureFlagsAndLimitsGuard implements CanActivate {
    constructor(
        private router: Router,
        private store: Store<FeatureFlagsAndLimitsState>
    ) { }

    canActivate() {
        this.store.select(selectDowntime).subscribe((downtime: any) => {
            if (downtime?.downtimeType === 1 || downtime?.downtimeType === 2) {
                this.router.navigate(["/total-downtime"]);
            }
            return false;
        })
        return true;
    }
}
